module.exports = __webpack_public_path__ + "public/adminIcons/RentALL-logo.png?112b2fdb";